import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React, { FC, useState } from 'react';
import Ticket from 'src/interfaces/api/Ticket';
import { createUseStyles } from 'src/theming';
import { useForm } from 'react-hook-form';

interface Props {
  ticket: Ticket;
  open: boolean;
  onClose: () => void;
  onOpenTicket: (id: string) => Promise<Ticket>;
}

const useStyles = createUseStyles({
  formField: {
    marginTop: '15px !important',
  },
  error: {
    color: '#f44336',
  },
});

const TicketOpenModal: FC<Props> = ({ ticket, open, onOpenTicket, onClose }) => {
  const [formError, setFormError] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);
  const { control, handleSubmit } = useForm();

  const classes = useStyles();

  const onSubmit = async () => {
    try {
      setLoading(true);

      await onOpenTicket(ticket.id);

      setLoading(false);
      setFormError(undefined);
      onClose();
    } catch (e) {
      setLoading(false);
      setFormError(e.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Réouverture du ticket</DialogTitle>

      <DialogContent>
        <DialogContentText>Vous allez réouvrir le ticket "{ticket.subject}"</DialogContentText>

        {formError && <p className={classes.error}>{formError}</p>}
      </DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' onClick={handleSubmit(onSubmit)} color='primary'>
          {loading && <CircularProgress color='primary' size={15} />} Valider
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketOpenModal;
